/**
 * @generated SignedSource<<2a71703876b6394edbd1b954e6810863>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailFramingOptions_refactor_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
  readonly " $fragmentType": "PdpSharedDetailFramingOptions_refactor_item";
};
export type PdpSharedDetailFramingOptions_refactor_item$key = {
  readonly " $data"?: PdpSharedDetailFramingOptions_refactor_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailFramingOptions_refactor_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailFramingOptions_refactor_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "3c02c116e24a4415e055e9ce935503c3";

export default node;
